// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"error","443":"about"}[chunkId] || chunkId) + "-legacy." + {"41":"5060decd","246":"024280e2","395":"0a6d7a79","443":"d840802b"}[chunkId] + ".js";
};